import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'coverImage',
    'coverDownload',
    'trackSelect',
    'trackDownload',
    'trackUpload',
    'coverContainer',
    'trackContainer',
    'trackSelectContainer',
    'trackResult',
    'trackIpfsUri',
    'trackPreview',
    'trackCopy',
  ];

  changeRelease(event) {
    const select = event.target;
    const { value, options } = select;
    const selectedOption = options[options.selectedIndex];
    const { coverUrl, smallCoverUrl } = selectedOption.dataset;
    if (coverUrl && smallCoverUrl) {
      this.coverImageTarget.src = smallCoverUrl;
      this.coverDownloadTarget.href = coverUrl;
      this.coverContainerTarget.hidden = false;
    } else {
      this.coverContainerTarget.hidden = true;
    }

    const trackValuePrefix = `${value}-`;
    const trackSelect = this.trackSelectTarget.querySelector('select');
    const trackSelectOptions = Array.from(trackSelect.options);
    const selectedTrackOption = trackSelectOptions.filter((option) =>
      option.value.startsWith(trackValuePrefix),
    );

    this.trackContainerTarget.hidden = true;
    trackSelect.value = '';
    if (selectedTrackOption.length > 0) {
      this.trackSelectContainerTarget.hidden = false;
      trackSelectOptions.forEach((option) => {
        option.hidden = !(option.value.startsWith(trackValuePrefix) || option.value === '');
      });
    } else {
      this.trackSelectContainerTarget.hidden = true;
    }
  }

  changeTrack(event) {
    const select = event.target;
    const value = select.value;
    const selectedOption = select.options[select.selectedIndex];
    const { trackUrl, trackFileName } = selectedOption.dataset;

    if (value && trackUrl) {
      this.trackDownloadTarget.href = trackUrl;
      this.trackResultTarget.hidden = true;
      this.trackUploadTarget.disabled = false;
      this.trackUploadTarget.dataset.trackUrl = trackUrl;
      this.trackUploadTarget.dataset.trackFileName = trackFileName;
      this.trackContainerTarget.hidden = false;
    } else {
      this.trackContainerTarget.hidden = true;
    }
  }

  async uploadTrack(event) {
    const button = event.target.closest('.o-button');
    button.disabled = true;
    button.classList.add('o-button--working');

    try {
      const thirdwebUrl = new URL('../scripts/thirdweb.min.js', import.meta.url).href;
      const { createThirdwebClient, upload } = await import(thirdwebUrl);

      const { trackUrl, trackFileName } = button.dataset;

      const client = createThirdwebClient({
        clientId: '0fa9ab25a44efe5a19a7a1c92b0dc941',
      });

      const file = await fetch(trackUrl).then(async (res) => {
        if (!res.ok) {
          throw new Error(`Failed to fetch track ${res.status} ${res.statusText}`);
        }
        return new Uint8Array(await res.arrayBuffer());
      });

      const uri = await upload({
        client,
        uploadWithoutDirectory: true,
        files: [{ data: file, name: trackFileName }],
      });

      const url = uri.replace('ipfs://', 'https://ipfs.io/ipfs/');
      this.trackIpfsUriTarget.textContent = uri;
      this.trackCopyTarget.dataset.uri = uri;
      this.trackPreviewTarget.href = url;
      this.trackResultTarget.hidden = false;
    } catch (e) {
      button.disabled = false;
      alert(`Error uploading track: ${e.message}`);
      throw e;
    } finally {
      button.classList.remove('o-button--working');
    }
  }

  copyIpfsUri(event) {
    const uri = event.target.closest('.o-button').dataset.uri;
    import('copy-text-to-clipboard').then((module) => module.default(uri));
  }
}
